import React, { useEffect, useState } from "react";
import "./Result.css";
import Navbar from "../../components/Navbar/Navbar";

/**Firebase Imports**/
import { auth, db, getDoc, doc } from "../../firebaseConfig";

const Result = () => {
	const [revenue, setRevenue] = useState("...");
	const [lessFixedCost, setLessFixedCost] = useState("...");
	const [lessVariableMilesCost, setLessVariableMilesCost] = useState("...");
	const [lessVariableMoneyCost, setLessVariableMoneyCost] = useState("...");

	/**
	 * Main Functions
	 * **/
	useEffect(() => {
		const getInputs = async () => {
			// Revenue
			const docSnapRevenue = await getDoc(
				doc(db, "weekly_loads", auth.currentUser.uid)
			);
			if (docSnapRevenue.exists()) {
				const loadsTemp = docSnapRevenue.data().loads;
				if (loadsTemp !== undefined) {
					const revenue = loadsTemp.reduce((x, a) => x + parseFloat(a.rate), 0);
					setRevenue(revenue);
				}
			}

			// Less Fixed
			const docSnapFixed = await getDoc(
				doc(db, "fixed_costs", auth.currentUser.uid)
			);
			if (docSnapFixed.exists()) {
				const annualInputsTemp = docSnapFixed.data().annualInputs;
				const monthlyInputsTemp = docSnapFixed.data().monthlyInputs;
				if (annualInputsTemp !== undefined && monthlyInputsTemp !== undefined) {
					const annualCost = annualInputsTemp.reduce(
						(x, a) => x + parseFloat(a.value),
						0
					);

					const monthlyCost = monthlyInputsTemp.reduce(
						(x, a) => x + parseFloat(a.value),
						0
					);
					setLessFixedCost(
						// (((annualCost / 12 + monthlyCost) * 12) / 52).toFixed(2)
						((monthlyCost * 12) / 52).toFixed(2)
					);
				}
			}

			//Less Variable Miles/$
			const docSnapMiles = await getDoc(
				doc(db, "variable_costs", auth.currentUser.uid)
			);
			const docSnapLoads = await getDoc(
				doc(db, "weekly_loads", auth.currentUser.uid)
			);
			if (docSnapMiles.exists()) {
				const milesInputsTemp = docSnapLoads.data().loads;
				const weekInputsTemp = docSnapMiles.data().weekInputs;
				const costPerGallonTemp = docSnapMiles.data().costPerGallon;
				const milePerGallonTemp = docSnapMiles.data().milePerGallon;
				const milesTemp = docSnapMiles.data().milesInputs;
				if (milesInputsTemp !== undefined && weekInputsTemp !== undefined) {
					// miles based

					setLessVariableMilesCost(
						milesInputsTemp.reduce((x, a) => x + parseFloat(a.miles), 0) *
							(milesTemp.reduce((x, a) => x + parseFloat(a.value), 0) +
								costPerGallonTemp /
									(milePerGallonTemp === 0 ? 1 : milePerGallonTemp))
					);

					// money based
					setLessVariableMoneyCost(
						weekInputsTemp.reduce((x, a) => x + parseFloat(a.value), 0)
					);
				}
			}
		};
		getInputs();
		return () => console.log("");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [auth.currentUser]);

	/** **/

	return (
		<div className="WeeklyBreakdown h-full w-full overflow-y-auto ">
			<div className="top-image w-full m-0 p-3 py-8 relative">
				<Navbar backTarget={"/weeklycost"} />

				<div className="bottom-container">
					<h1 className="result-heading">RESULT</h1>
					<div className="result-items" style={{ backgroundColor: "#E07A5F" }}>
						Total Revenue: <span>{parseFloat(revenue).toFixed(2)}</span>
					</div>
					<div className="result-items" style={{ backgroundColor: "#3D405B" }}>
						Less Fixed Cost: <span>{parseFloat(lessFixedCost).toFixed(2)}</span>
					</div>
					<div className="result-items" style={{ backgroundColor: "#81B29A" }}>
						Less Variable Cost <br />
						(Miles Based):{" "}
						<span>{parseFloat(lessVariableMilesCost).toFixed(2)}</span>
					</div>
					<div className="result-items" style={{ backgroundColor: "#F2CC8F" }}>
						Less Variable Cost <br />
						($ Based):{" "}
						<span>{parseFloat(lessVariableMoneyCost).toFixed(2)}</span>
					</div>
					<hr />
					<div
						className="result-items h-24"
						style={{ backgroundColor: "#9799CA", height: "100px" }}
					>
						Total <br /> Profit/ <br /> Loss:
						<span>
							{(
								parseFloat(revenue) -
								parseFloat(lessFixedCost) -
								parseFloat(lessVariableMoneyCost) -
								parseFloat(lessVariableMilesCost)
							).toFixed(2)}
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Result;
